export const approvalStatus = {
  title: "Approval Status",
  pending: "Pending",
  approved: "Approved",
  rejected: "Rejected",
  approve: "Approve",
  reject: "Reject"
}
